$(".image-grid").magnificPopup({
  delegate: ".img-popup", // child items selector, by clicking on it popup will open
  type: "image",
  gallery: { enabled: true },
});
